import React, { useEffect, useState } from 'react'
import './newParentChild.css'
import { Breadcrumb, Tooltip } from "antd"
import { Link, useLocation } from "react-router-dom";
import share_icon from '../../UserAssets/images/share.svg'
import Header from '../UserLayout/Header';
import ParentChildTreeResponsive from './ParentChildTreeResponsive';
import ParentChildTree from './ParentChildTree';
import { fetchAllParentChildTreeData } from '../../Redux/Api/fetch.api';
import Loader from '../loader';
import SupportRequest from '../UserLogin/SupportRequest';
import close_icon from "../../UserAssets/images/closewhite.svg";
import copy_icon from "../../UserAssets/images/copyicon.svg";
import email_icon from "../../UserAssets/images/mailicon.svg";
import Footer from '../UserLayout/Footer';

const NewParentChild = () => {
    const [data, setData] = useState({});
    const [isData, setIsdata] = useState(false)
    const { pathname } = useLocation()
    const [loading, setLoading] = useState(false)
    const [isSmallScreen, setisSmallScreen] = useState(window.innerWidth <= 1024)

    // const [currentId, setCurrentid] = useState(pathname.split('/').pop())
    const [backbutton, setBackButton] = useState(false);
    const [checkVirtualCode, setCheckVirtualCode] = useState();
    const [checkVirtualData, setCheckVirtualData] = useState()
    const [checkQRCode, setCheckQRCode] = useState();
    const [virtualCode, setVirtualCode] = useState();
    const [supportModalDisplay, setSupportModalDisplay] = useState(false);
    const baseUrl = window.location.origin;
    const [comingqrId, setComingQrId] = useState(null);
    const [currentId, setCurrentId] = useState(null);

    useEffect(() => {
        const treeContainer = document.querySelector('.tree-responsive');
        if (!treeContainer) return;

        // Make sure all <ul> elements are visible by default
        treeContainer.querySelectorAll('ul').forEach((ul) => {
            ul.style.display = 'block';
        });

        treeContainer.querySelectorAll('li').forEach((li) => {
            const subUl = li.querySelector(':scope > ul');
            if (subUl) {
                li.classList.add('has-children');

                const toggleIcon = document.createElement('i');
                toggleIcon.textContent = '-'; // expanded by default
                toggleIcon.className = 'js-toggle-icon';
                li.insertBefore(toggleIcon, li.firstChild);

                toggleIcon.addEventListener('click', () => {
                    const isExpanded = toggleIcon.textContent === '+';
                    toggleIcon.textContent = isExpanded ? '-' : '+';
                    subUl.style.display = isExpanded ? 'block' : 'none';
                });
            }
        });
    }, [data, isSmallScreen]);


    useEffect(() => {
        const handleResize = () => {
            setisSmallScreen(window.innerWidth <= 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        getparentchilddata(0);
    }, []);

    const getparentchilddata = (qrcode) => {
        setComingQrId(qrcode)
        setLoading(true)
        let comingid = 0;
        if (qrcode) {
            comingid = qrcode;
        }
        else {
            let urlData = location.pathname.split("/");
            if (urlData[2].length < 9) {
                // setCurrentVirtualId(urlData[1])
                setCurrentId(urlData[2]);
                comingid = parseInt(urlData[2])
            }
        }
        if (comingid) {
            getQRDetailsonLoad(comingid);
        }
    }
    const getQRDetailsonLoad = (comingid) => {
      
        // fetchAllParentChildQRId(comingid)
        fetchAllParentChildTreeData(comingid)
            .then((response) => {
                if (response.data.success) {
                    setLoading(false)
                    // dispatch(getQrParentChildData(response.data.data));
                    setCheckVirtualCode(response.data.data.isVirtualCode)
                    setCheckQRCode(response.data.data.checkQRCode)
                    // setVirtualData(response.data.data)
                    // setVirtualCode(response.data.data.virtualQRCode)
                    // setCheckVirtualData(response.data.data.checkVirtualCode)
                    // setCurrentId(urlData[1]);
                    setLoading(false)
                    const childQRDetails = response.data.data.childQrDetails;
                    const scanedQRDetails = response.data.data.scanedQRDetails;
                    if (Object.keys(scanedQRDetails).length > 0) {
                        setIsdata(true)
                    } else {
                        setIsdata(false)
                    }

                    if (scanedQRDetails) {
                        setData({
                            ...scanedQRDetails,
                            children: childQRDetails,
                            // children: [],    
                            isExpanded: true
                        });
                    }
                }
                else {
                    setErrorMessage("Qr Code is not valid, please try again.");
                    history.push("/NotFound")
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const updateNodeByPath = (id, parentNode, newChildren, path) => {
        setData(prevData => {
            const clone = structuredClone(prevData);

            let current = clone;
            let parent = null;
            let parentChildren = null;

            for (let i = 0; i < path.length; i++) {
                parent = current;
                parentChildren = parent.children;
                current = parentChildren[path[i]];
            }

            current.isExpand = parentNode.isExpand;
            current.product_Name = parentNode.product_Name;
            current.children = newChildren ? newChildren : [];

            return clone;
        });
    };

    const next = (qrCode) => {
        setBackButton(true)
        qrCode ? history.push({
            pathname: "/" + qrCode, state: {
                parentQrCodeId: currentId
            }
        }) : "";
    };

    const handleCloseButton = (e) => {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector('.dropdown-menu.share-link').classList.remove('show');
    };
    const copyToClipboard = () => {
        const baseUrl = window.location.origin;
        const link = `${baseUrl}/${currentId}`;
        // const link = `https://tekahelp.com/${currentId}`;
        navigator.clipboard.writeText(link)
            .then(() => {
                alert('Link copied to clipboard!');
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
            });
    };
    return (
        <React.Fragment>
            <Header
                isSupportIcon={true}
                isCurrentid={currentId}
                isBackButton={backbutton}
                setSupportModalDisplay={setSupportModalDisplay}
            ></Header>

            <section className="new-parent-child">
                {loading && <Loader />}
                <div className="Support-request-show">
                    <SupportRequest supportModalDisplay={supportModalDisplay} setSupportModalDisplay={setSupportModalDisplay} />
                </div>
                <div className='tree-preview'>
                    <div className="d-flex justify-content-between align-items-center mb-3 position-relative">
                        <Breadcrumb className="breadcrumb QrParentChild ms-0">
                            <Breadcrumb.Item>
                                <a href={`/${currentId}`}>
                                    <i class="fa-solid fa-house"></i>
                                </a>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <a href={`/${currentId}`}>

                                    {currentId}
                                </a>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="dropdown shareDropdown" style={{ right: '0', top: '0' }}>
                            <Tooltip title="Click to Share Link">
                                <button className="btn btn-bordered dropdown-toggle share-dropdown"
                                    // title="Click to Share Link"
                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    Share <img src={share_icon} className=""></img>
                                </button>
                            </Tooltip>
                            <div className="dropdown-menu share-link" aria-labelledby="dropdownMenuButton"

                            >
                                <div className="qr_head share-text">
                                    <h5>Share Link</h5>
                                    <span className="cls_icn close" onClick={handleCloseButton} data-dismiss="dropdown" aria-label="Close" role="button">
                                        <img src={close_icon} alt="Close" />
                                    </span>
                                </div>

                                <div>
                                    <div className="listing" onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
                                        <img src={copy_icon} /> Copy Link
                                    </div>
                                    <div className="listing">
                                        <a href={`mailto:?subject=&body=Check out this link: ${baseUrl}/${currentId}`} className="email-link">
                                            <img src={email_icon} alt="Email Link" style={{ marginRight: '13px' }} />
                                            Email
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="overflow-scroll-box">
                        {isData && (
                            <ul className="tree-root">
                                {!isSmallScreen && (
                                    <ParentChildTree updateNode={updateNodeByPath} node={data} />
                                )}
                            </ul>
                        )
                            // : (
                            //     <div className="m-auto text-center">No Data</div>
                            // )
                        }
                    </div>

                </div>


                <div className="d-flex justify-content-between align-items-center mb-3 position-relative mobile-breadcrumb">
                    <Breadcrumb className="breadcrumb QrParentChild ms-0">
                        <Breadcrumb.Item>
                            <a href={`/${currentId}`}>
                                <i class="fa-solid fa-house"></i>
                            </a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <a href={`/${currentId}`}>

                                {currentId}
                            </a>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="dropdown shareDropdown" style={{ right: '0', top: '0' }}>
                        <Tooltip title="Click to Share Link">
                            <button className="btn btn-bordered dropdown-toggle share-dropdown"
                                // title="Click to Share Link"
                                type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                Share <img src={share_icon} className=""></img>
                            </button>
                        </Tooltip>
                        <div className="dropdown-menu share-link" aria-labelledby="dropdownMenuButton"

                        >
                            <div className="qr_head share-text">
                                <h5>Share Link</h5>
                                <span className="cls_icn close" onClick={handleCloseButton} data-dismiss="dropdown" aria-label="Close" role="button">
                                    <img src={close_icon} alt="Close" />
                                </span>
                            </div>

                            <div>
                                <div className="listing" onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
                                    <img src={copy_icon} /> Copy Link
                                </div>
                                <div className="listing">
                                    <a href={`mailto:?subject=&body=Check out this link: ${baseUrl}/${currentId}`} className="email-link">
                                        <img src={email_icon} alt="Email Link" style={{ marginRight: '13px' }} />
                                        Email
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {isData && (
                    <ul className="tree-responsive">
                        {isSmallScreen && (
                            <ParentChildTreeResponsive
                                updateNode={updateNodeByPath}
                                node={data}
                            />
                        )}
                    </ul>
                )
                    // : (
                    //     isSmallScreen && (
                    //         <div className="m-auto text-center">No Data</div>
                    //     ))
                }
            </section>
            {currentId &&
                <Footer qrcodeId={currentId} />
            }
        </React.Fragment>
    )
}

export default NewParentChild